let config = {
    basURL: "https://api.khaled-sakr-store.com/",
};

export default config;
